<template>
    <transition name="fade">
        <div class="fixed z-50 inset-0 overflow-y-auto" v-if="active">
            <div
                class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            >
                <!--
              Background overlay, show/hide based on modal state.

              Entering: "ease-out duration-300"
                From: "opacity-0"
                To: "opacity-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100"
                To: "opacity-0"
            -->
                <div class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                    class="hidden sm:inline-block sm:align-middle sm:h-screen"
                ></span
                >&#8203;
                <!--
              Modal panel, show/hide based on modal state.

              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
                <div
                    class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full vh-space overflow-y-auto"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-headline"
                >
                <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div class="flex bg-white justify-between">
                            <div>
                                <ul
                                    class="flex mb-6"
                                    v-if="tabs.length > 1"
                                >
                                    <li v-for="(tab, index) in tabs"
                                        @click.prevent="updateMediaType(tab.type)"
                                        class="mr-1"
                                    >
                                        <a
                                            :class="anchorClass(tab.type)"
                                            class="bg-white inline-block py-2 px-4 font-semibold"
                                            href="#"
                                        >
                                            {{tab.text}}
                                        </a>
                                    </li>

                                </ul>
                            </div>
                            <div
                                class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                            >
                                <span
                                    class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                                >
                                    <btn
                                        type="button"
                                        content="Close popup"
                                        @click="close"
                                    />
                                </span>
                            </div>
                        </div>
                        <div
                            class="sm:flex sm:flex-col sm:items-center justify-between"
                        >
                            <div
                                class="w-full md:w-3/4 mx-auto mb-6"
                                v-if="upload"
                            >
                                <input-image
                                    @uploaded="uploaded"
                                    label="Upload"
                                    :language="language"
                                    :uploadRoute="uploadRoute"
                                ></input-image>
                            </div>
                            <media-library
                                :multiple="multiple"
                                selector
                                updatable-selector
                                v-model="selected"
                                :media-data="media"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import MediaLibrary from "./MediaLibrary";
import media from "../../mixins/media";
import siteLanguage from '../../config/siteLanguage';
import mediaTabs from './MediaTabs'

export default {
    name: "MediaReferenceModal",
    components: { MediaLibrary },
    mixins: [media],
    props: {
        value: Array,
        active: {
            type: Boolean,
            required: true,
        },
        file: Object,
        multiple: Boolean,
        upload: {
            type: Boolean,
            default: true,
        },
        mediaTypes: {
            type: Array,
            required: false,
            default: () => {
                return ["Media"] ;
            },
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    created() {
        let vm = this;
        this.getMediaItems();
        window.addEventListener("keydown", function (evt) {
            if (evt.key === 'Escape' || evt.keyCode === 27) {
                vm.close();
            }
        }, false);
    },
    updated() {
        this.$emit("input", this.selected);
    },
    data() {
        return {
            isModalOpen: false,
            selected: this.value || [],
            media: [],
            selectedMediaType: this.mediaTypes[0] != "Media" ? this.mediaTypes[0] : mediaTabs.tabs[0].type,
            tabs: this.getMediaTabs()
        };
    },
    methods: {
        uploaded(file) {
            this.media.unshift(file);
            if (!this.multiple) {
                this.selected.length = 0;
            }
            this.selected.push(file);
        },
        getMediaTabs() {
            if (this.mediaTypes.includes('Media')) {
               return mediaTabs.tabs;
            } else {
                let tabs = [];
                for(let tab = 0; tab < mediaTabs.tabs.length; tab++) {
                    if (this.mediaTypes.includes(mediaTabs.tabs[tab].type)) {
                        tabs.push(mediaTabs.tabs[tab]);
                    }
                }
                return tabs;
            }
        },
        async getMediaItems() {
            const response = await axios
                .get(this.indexRoute)
                .catch((err) => console.error(err.response || err));
            this.media = response.data;
        },
        updateMediaType(type) {
            this.selectedMediaType = type;
            this.media = [];
            this.getMediaItems();
        },
        anchorClass(type) {
            return this.selectedMediaType === type
                ? 'text-blue-800 border-l border-t border-r rounded-t'
                : 'text-blue-500 hover:text-blue-900';
        },
        close() {
            this.$emit('closed');
        }
    },
};
</script>
